import React from 'react'

// DEV-2980: the storefront's filter-bar icons (cb-storefront
// plp/listing/icons.tsx): 1.5 stroke, currentColor.
const base = {
  fill: 'none', stroke: 'currentColor', strokeWidth: 1.5,
  strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true, focusable: false,
}

export function ChevronIcon() {
  return <svg className="fb-chev" width="10" height="10" viewBox="0 0 12 12" {...base}><path d="M2.5 4.5 6 8l3.5-3.5" /></svg>
}

export function CheckIcon() {
  return <svg className="fb-check" width="14" height="14" viewBox="0 0 16 16" {...base}><path d="M3 8.5l3 3 7-7" /></svg>
}

export function SortIcon() {
  return <svg width="13" height="13" viewBox="0 0 16 16" {...base}><path d="M3 4h10M4.5 8h7M6.5 12h3" /></svg>
}

export function FunnelIcon() {
  return <svg width="13" height="13" viewBox="0 0 16 16" {...base}><path d="M1.5 2.5h13l-5 6v4l-3 1.6V8.5z" /></svg>
}

export function CloseIcon() {
  return <svg width="18" height="18" viewBox="0 0 24 24" {...base}><path d="M6 6l12 12M18 6L6 18" /></svg>
}

export function XIcon() {
  return <svg width="11" height="11" viewBox="0 0 12 12" {...base} strokeLinejoin={undefined}><path d="M3 3l6 6M9 3l-6 6" /></svg>
}

export function SearchSmall({ size = 14 }) {
  return <svg width={size} height={size} viewBox="0 0 18 18" {...base}><circle cx="8" cy="8" r="5.5" /><path d="M12.2 12.2 16 16" /></svg>
}
